"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buttonContentStyles = void 0;
exports.buttonContentStyles = {
    root: function () {
        return {
            fontWeight: "var(--button__content--font-weight, 400)",
        };
    },
};
//# sourceMappingURL=buttonContent-styles.js.map